import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { _single } from "../../../../core/services/dataBean/EntityCatalog";
import { InputDate } from "../../../theme/Input/InputDate";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { HealthID } from "../../../admin/configuracion/HealthID/HealthID";
import { _CIUO88ACAccount, _HealthDisabilityAccount } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { HealthIDEditor } from "../../../admin/configuracion/HealthID/HealthIDEditor";
import { HealthDisabilityTypeEditor } from "../../../Inventories-Warehouses/Product/HealthDisabilityType/HealthDisabilityTypeEditor";


interface Props {
    accountID: number;
}

export const HealthDisabilityAccount = ({ accountID }: Props) => {

    const disacc = useDataBean(_HealthDisabilityAccount);
    const single = Singleton.getInstance();
    const [fromDate, setfromDate] = useState<any>(null);
    const [form, setForm] = useState<any>({
        IDHealthDisabilityType: null,
        HealthDisabilityTypeName: null
    });
    const [NameSelect, setNameSelect] = useState<any>(null);
    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [accountID])

    const getLista = () => {

        disacc.instance.getHealthDisabilityAccountCatalog(accountID, fromDate).then(
            (resp: any) => {
                if (resp) {
                    let x = resp;
                    x.forEach((user) => {
                        user.DataBeanProperties.TypeHealth = (user.DataBeanProperties.Code ?? "") + "-" + (user.DataBeanProperties.Name ?? "");
                    });
                    setLista(x)
                }
            }
        )

    }

    const create = () => {
        disacc.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        disacc.instance.deleteVoid(disacc.bean.IDHealthDisabilityAccount).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const addCIUO88ACAccountCatalog = () => {

        disacc.instance.addHealthDisabilityAccount(accountID, form.IDHealthDisabilityType, disacc.bean.FromDate, _single.getAccountID()).then(
            (resp: any) => {
                console.log(resp)
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }


    const head = [
        { title: 'ID', property: 'IDHealthDisabilityAccount', visible: true },
        { title: 'Tipo de Incapacidad', property: 'TypeHealth', visible: true },
        { title: 'Tercero', property: 'AccountName', visible: true },
        { title: 'Fecha Inicio', property: 'FromDate', visible: true },
        { title: 'Creado', property: 'EmployeeName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            // { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <label>Discapacidades Físicas</label>
            <div className="col-md-4">
                <InputDate name="Fecha" value={fromDate} label="Fecha" setDate={(e) => setfromDate(e)} />
            </div>
            <div className="col-md-4 mt-4 p-2">
                <BasicButton icon="" eventClick={getLista}>Buscar</BasicButton>
            </div>
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={disacc.setBean} iconButtons={iconButtonsItem} listButtons={listaBotones()}></BasicTable>
                <Modal modal={modal} updateModal={setModal} eventModal={addCIUO88ACAccountCatalog}>
                    <div className="row">
                        <div className="col-md-12">
                            <InputDate name="Fecha Desde" value={disacc.bean.FromDate} label="Fecha Inicio Ocupación" setDate={(e: any) => { disacc.setBean({ ...disacc.bean, "FromDate": e }) }} />
                        </div>
                        <div className="col-md-12">
                            <HealthDisabilityTypeEditor render={form.HealthDisabilityTypeName} idSelector={form.IDHealthDisabilityType} onChange={(e) => { setForm({ ...form, "IDHealthDisabilityType": e.IDHealthDisabilityType, "HealthDisabilityTypeName": e.Name }) }} returnType="Object" />
                        </div>
                    </div>
                </Modal>

                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>
        </div>
    )
}